import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

export const useLanguageStore = defineStore(
  'language',
  () => {
    const { locale } = useI18n()

    const currentLanguage = ref('zh') // 默认中文p

    // 中英文切换 zh en
    const switchLanguage = (language) => {
      return new Promise((resolve) => {
        if (language) {
          currentLanguage.value = language
          locale.value = language
        } else {
          const language = currentLanguage.value === 'zh' ? 'en' : 'zh'
          currentLanguage.value = language
          locale.value = language
        }
        resolve(currentLanguage.value)
      })
    }

    const getLanguage = () => currentLanguage.value

    onMounted(() => {
      // 刷新页面会丢失语言，故要重新设置
      locale.value = currentLanguage.value
    })

    return {
      currentLanguage,
      switchLanguage,
      getLanguage
    }
  },
  {
    persist: true
  }
)
